import React, { useState, useEffect, useRef } from "react";
import { FaArrowUp, FaMapMarkerAlt } from "react-icons/fa";
import { DocInfoCard } from "./DoctorAppointment.styles";
import NavigateNextSharpIcon from "@mui/icons-material/NavigateNextSharp";
import { Link, useLocation, useParams } from "react-router-dom";
import Doctor from "../images/doctorAvtar.png";
import Doctors from "../images/callUs.png";
import axios from "axios";
import DoctorAppointmentSlots from "./DoctorAppointmentSlots";
import { setDoctorDetails } from "../reduxtool/action";
import { useDispatch, useSelector } from "react-redux";
import { GetAllDoctorsService } from "../Services/TabServices";
import { Toast } from "../Marketing/Common/Toast";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

interface Experience {
  role: string;
  description: string;
}

interface Area {
  role: string;
  description: string;
}

interface DoctorDetail {
  profileBrief: string;
  previousExperiance: Experience[];
  awardsAchievements: string[];
  areaOfInterest: Area[];
  researchPublications: string[];
  registrationNo: string;
}

interface DoctorLocation {
  locationId: number;
  locationName: string;
  hospitalName: string;
}

interface SecondaryLocation {
  LocationId: number;
  LocationName: string;
  hospitalName: string;
}
const DoctorAppointment = () => {
  const location = useLocation();
  const sectionRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const containerRef = useRef<HTMLDivElement | null>(null);
  const dispatch: any = useDispatch();

  const { speciality, doctorName, locationName }: any = useParams();
  const { doctorData: navDoctorData, specializationId: navSpecializationId, doctorId: navDoctorId } = location.state || {};
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [doctors, setDoctors] = useState<any[]>([]);
  const [matchedDoctor, setMatchedDoctor] = useState<any>(null);
  const [doctorId, setDoctorId] = useState<number | null>(navDoctorId || null);
  const [specializationId, setSpecializationId] = useState<number | null>(navSpecializationId || null);
  const [selectedDepartmentId, setDepartmentId] = useState<number | null>(null);

  const [doctordata, setDoctorData] = useState<DoctorDetail | null>(null);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [description, SetDescripiton] = useState<string | null>(null);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [callbackMobile, setCallbackMobile] = useState("");
  const [callbackName, setCallbackName] = useState("");
  const [callbackConsent, setCallbackConsent] = useState(false);
  const [callbackLoading, setCallbackLoading] = useState(false);
  const [preferredDate, setPreferredDate] = useState("");
  const [preferredTime, setPreferredTime] = useState("");
  const [nextSevenDays, setNextSevenDays] = useState<{ date: string; day: string }[]>([]);
  const [pdfOpen, setPdfOpen] = useState(false);
  const [doctorAvailabilityFound, setDoctorAvailabilityFound] = useState<boolean>(true);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [submittedData, setSubmittedData] = useState<any>({});
  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [isNameValid, setIsNameValid] = useState(false);
  const [isMobileValid, setIsMobileValid] = useState(false);
  const [availableLocations, setAvailableLocations] = useState<DoctorLocation[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<DoctorLocation | null>(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isDoctorloading, setDoctorLoading] = React.useState(false);
const [callbackEmail, setCallbackEmail] = useState("");
const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState('');

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const source = /Android|iPhone/i.test(navigator.userAgent)
    ? "OAS-Website-Mobile"
    : "OAS-Website-Desktop";
const toTitleCase = (name: string): string => {
  return name
    .trim()
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
};


const validateEmail = (email: string): boolean => {
  // optional field
  if (!email.trim()) {
    setEmailError("");
    return true;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(email)) {
    setEmailError("Please enter a valid email address");
    return false;
  }

  setEmailError("");
  return true;
};
  useEffect(() => {
    const handleScroll = () => setShowScrollTop(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const getMinDate = () => new Date().toISOString().split('T')[0];

  const getMaxDate = () => {
    const today = new Date();
    today.setDate(today.getDate() + 7);
    return today.toISOString().split('T')[0];
  };

  const handleDoctorAvailabilityChange = (isAvailable: boolean) => {
    setDoctorAvailabilityFound(isAvailable);
  };

  const normalizeSlug = (str: string | undefined | null) => {
    if (!str) return "";
    return str.toLowerCase().trim().replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
  };

  const validateName = (name: string) => {
    const trimmedName = name.trim();
    setIsNameValid(trimmedName.length >= 3);
    if (trimmedName.length < 3 && trimmedName.length > 0) setNameError("Name must be at least 3 characters long.");
    else setNameError("");
  };

  const validateMobile = (mobile: string) => {
    const phoneRegex = /^[0-9]{10}$/;
    setIsMobileValid(phoneRegex.test(mobile));
    if (mobile.length > 0 && !phoneRegex.test(mobile)) setMobileError("Please enter a valid 10-digit phone number.");
    else setMobileError("");
  };

  const getDoctorLocations = (doctor: any): DoctorLocation[] => {
    const locations: DoctorLocation[] = [];
    if (doctor.location) {
      locations.push({
        locationId: doctor.locationId || 0,
        locationName: doctor.location,
        hospitalName: doctor.hospitalName || doctor.location,
      });
    }
    if (doctor.secondaryLocations && Array.isArray(doctor.secondaryLocations)) {
      doctor.secondaryLocations.forEach((secLoc: SecondaryLocation) => {
        locations.push({
          locationId: secLoc.LocationId,
          locationName: secLoc.LocationName,
          hospitalName: secLoc.hospitalName,
        });
      });
    }
    return locations;
  };

  // STEP 1: Fetch all doctors
  useEffect(() => {
    setDoctorLoading(true);
    const getData = async () => {
      try {
        const res = await GetAllDoctorsService();
        setDoctors(res?.data || []);
           setDoctorLoading(false); 
      } catch (err) {
        console.error("❌ Error fetching doctors", err);
           setDoctorLoading(false); 
      }
    };
    getData();
  }, []);


  useEffect(() => {
    if (doctors.length === 0) return;
      setDoctorLoading(true);
    if (navDoctorId) {
      const matchedDoc = doctors.find((doc) => doc.doctorId === navDoctorId);
      if (matchedDoc) {
        setMatchedDoctor(matchedDoc);
        setDoctorId(matchedDoc.doctorId);
        setSpecializationId(matchedDoc.specializationId);
        setDepartmentId(matchedDoc.departmentId);
        dispatch(setDoctorDetails(matchedDoc.doctorId));
        const locations = getDoctorLocations(matchedDoc);
        setAvailableLocations(locations);
            if (locations.length > 0) setSelectedLocation(locations[0]);
        setDoctorLoading(false);
      } else {
        console.warn("❌ No doctor found with doctorId:", navDoctorId);
        setDoctorLoading(false);
      }
      return; 
    }

    
    if (!doctorName || !speciality || !locationName) {
      console.warn("⚠️ Missing URL parameters");
      return;
    }

    const matchedDoc = doctors.find((doc) => {
      const docNameSlug = normalizeSlug(doc.doctorName);
      const specSlug = normalizeSlug(doc.specializationName || doc.specialization);
      const locSlug = normalizeSlug(doc.location);
      return docNameSlug === doctorName && specSlug === speciality && locSlug === locationName;
    });

    if (matchedDoc) {
      setMatchedDoctor(matchedDoc);
      setDoctorId(matchedDoc.doctorId);
      setSpecializationId(matchedDoc.specializationId);
      dispatch(setDoctorDetails(matchedDoc.doctorId));
      const locations = getDoctorLocations(matchedDoc);
      setAvailableLocations(locations);
      if (locations.length > 0) setSelectedLocation(locations[0]);
            setDoctorLoading(false);
    } else {
      console.warn("❌ No doctor matched the given URL params");
    }
  }, [doctors, navDoctorId, doctorName, speciality, locationName, dispatch]);

  // STEP 3: Fetch doctor profile details once doctorId is set
  useEffect(() => {
    if (!doctorId) return;
    const fetchDoctor = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/patient/getdoctorprofilebyid?DrId=${doctorId}`);

        const data = res.data[0];
        data.previousExperiance = data.previousExperiance ? JSON.parse(data.previousExperiance) : [];
        data.awardsAchievements = data.awardsAchievements ? JSON.parse(data.awardsAchievements) : [];
        data.areaOfInterest = data.areaOfInterest ? JSON.parse(data.areaOfInterest) : [];
        data.researchPublications = data.researchPublications ? JSON.parse(data.researchPublications) : [];
        setDoctorData(data);
      } catch (err) {
        console.error("❌ Error fetching doctor profile", err);
      }
    };
    fetchDoctor();
  }, [doctorId]);

  // STEP 4: Generate next 7 days
  useEffect(() => {
    const getNextSevenDays = (): { date: string; day: string }[] => {
      const daysArray: { date: string; day: string }[] = [];
      const options: Intl.DateTimeFormatOptions = { weekday: "long" };
      for (let i = 1; i < 8; i++) {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + i);
        daysArray.push({
          date: currentDate.toISOString().split("T")[0],
          day: new Intl.DateTimeFormat("en-US", options).format(currentDate).slice(0, 3),
        });
      }
      return daysArray;
    };
    const days = getNextSevenDays();
    setNextSevenDays(days);
    if (days.length > 0) setSelectedDate(days[0].date);
  }, []);

  const doctorDetail = useSelector((state: any) => state.selectedDoctorDetails);

  const tiles = [
    doctordata?.profileBrief ? "Overview" : null,
    doctordata?.previousExperiance?.length ? "Experience" : null,
    doctordata?.awardsAchievements?.length ? "Awards & Achievements" : null,
    (doctordata?.researchPublications?.length ?? 0) > 0 ? "Research & Publication" : null,
    doctordata?.areaOfInterest?.length ? "Areas of Interest" : null,
    doctordata?.registrationNo ? "Registration No" : null,
  ].filter(Boolean) as string[];

  const scrollToSection = (section: string) => sectionRefs.current[section]?.scrollIntoView({ behavior: "smooth" });

  const handleLocationSelect = (location: DoctorLocation) => setSelectedLocation(location);

  const handleCallbackSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const isEmailValid = validateEmail(callbackEmail);

if (!isEmailValid) {
  return;
}
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(callbackMobile)) { Toast.error("Please enter a valid 10-digit phone number."); return; }
    if (!callbackName || !callbackConsent) { Toast.error("Please fill in all fields and accept consent."); return; }
    if (!executeRecaptcha) { Toast.error('reCAPTCHA not ready. Please try again.'); setLoading(false); return; }

    const recaptchaToken = await executeRecaptcha('callback_request');
    if (!recaptchaToken) { setMessage('Captcha verification failed. Please try again.'); setLoading(false); return; }

    setCallbackLoading(true);
    const formattedName = toTitleCase(callbackName);

    try {
      const apiPayload = {
        name: formattedName,
          emailId: callbackEmail,
        mobileNo: callbackMobile,
        doctorId: doctorId,
        locationId: selectedLocation?.locationId || doctorDetail[0]?.locationId || 0,
        specializationId: Number(doctorDetail[0]?.departmentId || selectedDepartmentId),
        isConsent: callbackConsent,
        preferredDate: preferredDate || null,
        preferredTime: preferredTime || null,
        recaptchaToken,
        requestFor:"DD",
        source:source
      };
   const response=   await axios.post(`${process.env.REACT_APP_BASE_URL}/api/Patient/RequestCallBack`,
         apiPayload, { headers: { "Content-Type": "application/json" } });

   if (response.status === 200) {
                try {
          await axios.post(
            "https://integration.pqa.salesmax.ai/salesmax/leads?token=7MAcfjLhv7ITPcK_u2Eqxw",
            {
            name: formattedName,
              email: callbackEmail,
        mobileNo: callbackMobile,
        doctorId: doctorId,
        locationId: selectedLocation?.locationId || doctorDetail[0]?.locationId || 0,
        specializationId: Number(doctorDetail[0]?.departmentId || selectedDepartmentId),
        isConsent: callbackConsent,
        preferredDate: preferredDate || null,
        preferredTime: preferredTime || null,
        
     
        source:source
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        } catch (webhookError) {
          console.error("Salesmax webhook failed:", webhookError);
        }
               
              } else {
                throw new Error("API error");
              }
      setSubmittedData({ name: callbackName, mobile: callbackMobile, date: preferredDate, time: preferredTime });
      setShowSuccessModal(true);
      setCallbackName("");
      setCallbackMobile("");
      setCallbackConsent(false);
      setPreferredDate("");
      setPreferredTime("");
    } catch (error) {
      Toast.error("Submission failed. Please try again.");
    } finally {
      setCallbackLoading(false);
    }
  };

  // Show loader while fetching doctors OR while doctorDetail isn't ready yet
if (isDoctorloading || !doctorDetail || doctorDetail.length === 0) {
  return (
    <div className="relative w-full h-[200px] flex justify-center items-center py-10">
      <div className="absolute top-2/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 loader"></div>
    </div>
  );
}


  return (
    <div className="w-full xl:w-[85%] 2xl:w-[70%] mx-auto">
      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 transform transition-all animate-fadeIn">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
                <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <div className="text-center mb-6">
              <h2 className="text-2xl font-bold text-[#184A84] mb-3">Request Submitted Successfully!</h2>
              <p className="text-gray-600 text-base leading-relaxed">Thank you for your request. Our healthcare team will contact you within 24 hours at your preferred time.</p>
            </div>
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Name:</span>
                  <span className="font-semibold text-gray-900 capitalize">{submittedData.name || "N/A"}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Mobile:</span>
                  <span className="font-semibold text-gray-900">{submittedData.mobile || "N/A"}</span>
                </div>
              </div>
            </div>
            <button onClick={() => setShowSuccessModal(false)} className="w-full bg-[#009A85] hover:bg-[#007a6a] text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 transform hover:scale-[1.02] active:scale-95 shadow-lg">Close</button>
          </div>
        </div>
      )}

      {showScrollTop && (
        <button onClick={scrollToTop} className="fixed right-2 bottom-28 z-50 bg-[#009A85] hover:bg-[#007a6a] text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 active:scale-95 border-2 border-white/20 backdrop-blur-sm" title="Scroll to top" aria-label="Scroll to top">
          <FaArrowUp className="w-5 h-5" />
        </button>
      )}

      <div className="flex flex-col lg:gap-5 w-full px-2 xs:px-4 lg:flex-row">
        <div className="w-full">
          <div className="bg-white">
            <div className="text-black text-lg sm:text-xl md:text-2xl font-medium">Doctor Information</div>
            <div className="px-2 flex items-center">
              <Link className="no-underline text-[#606060] text-[12px] xs:text-[15px] font-medium" to={specializationId ? `/doctors` : "/doctors"}>Doctors</Link>
              <NavigateNextSharpIcon />
              <Link className="no-underline capitalize text-[#009A85] text-[12px] xs:text-[15px] font-medium" to="">{doctorDetail[0]?.doctorName}</Link>
            </div>
          </div>

          <DocInfoCard>
            <div className="flex flex-col sm:flex-row justify-between w-full border-transparent my-5">
              <div className="w-full md:w-[40%] p-2 md:p-5 flex justify-center">
                <div className="rounded-lg overflow-hidden flex justify-center items-center w-auto h-60 max-w-60 sm:max-w-50 md:max-w-60 lg:max-w-65 xl:max-w-65">
                  {doctorDetail[0]?.doctorImage ? (
                    <img src={`${process.env.REACT_APP_BASE_URL}/${doctorDetail[0]?.doctorImage}`} alt="Doctor" className="w-full h-full object-cover cursor-pointer" />
                  ) : (
                    <img src={Doctor} alt="Doctor" className="w-full h-full object-cover cursor-pointer" />
                  )}
                </div>
              </div>

              <div className="w-full md:w-[70%] px-4 md:px-5 flex flex-col gap-3 text-left">
                <div className="font-semibold text-lg md:text-xl text-black capitalize">{doctorDetail[0]?.doctorName}</div>
                <div className="text-gray-500 text-sm md:text-base">{doctorDetail[0]?.specializationName} ({doctorDetail[0]?.departmentName})</div>
                <div className="inline-block border border-[#009A85] px-3 py-1 rounded-lg text-[#009A85] text-sm md:text-[14px] w-fit">{`${doctorDetail[0]?.experienceYears}+ Years experience`}</div>
                <div className="text-gray-500 text-sm md:text-base">
                  {doctorDetail?.[0]?.qualification?.split(';').map((item: any) => item.trim()).filter(Boolean).map((item: any, index: any) => <div key={index}>{item}</div>) || <span className="text-sm">No qualifications listed</span>}
                </div>
                <div className="flex flex-wrap gap-2">
                  {doctorDetail[0]?.languages
                    ? doctorDetail[0].languages.split(",").map((lang: any, idx: any) => (
                        <span key={idx} className="border border-[#184A84] px-2 py-1 rounded-lg text-xs md:text-[14px] text-[#184A84]">{lang.trim()}</span>
                      ))
                    : <span className="text-sm">No languages listed</span>}
                </div>

                {/* Location Selection */}
                {availableLocations.length > 0 && (
                  <div className="flex flex-col gap-2 mt-2">
                    {availableLocations.map((loc, idx) => (
                      <label
                        key={idx}
                        className={`flex flex-row items-center gap-4 max-w-md w-fit rounded-lg border px-4 cursor-pointer transition-all ${selectedLocation?.locationId === loc.locationId ? 'border-[#184A84] bg-[#184A84]/5 text-[#184A84]' : 'border-[#0099A8] hover:border-[#184A84]/75 text-[#0099A8]'}`}
                        onClick={() => handleLocationSelect(loc)}
                      >
                        <input type="radio" name="doctor-location" checked={selectedLocation?.locationId === loc.locationId} onChange={() => handleLocationSelect(loc)} className="sr-only" />
                        <div className="flex items-center gap-3 text-xs flex-1 transition-colors">
                          <div className={`w-4 h-4 rounded-full border flex items-center justify-center flex-shrink-0 transition-colors ${selectedLocation?.locationId === loc.locationId ? 'border-[#184A84]' : 'border-[#0099A8]'}`}>
                            {selectedLocation?.locationId === loc.locationId && <div className="w-2 h-2 rounded-full bg-[#184A84]" />}
                          </div>
                          <span className="leading-snug truncate">{loc.hospitalName}, {loc.locationName}</span>
                        </div>
                        <div className="ml-auto p-2 rounded-full bg-white shadow-sm"><FaMapMarkerAlt className="w-3 h-3 flex-shrink-0" /></div>
                      </label>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </DocInfoCard>
        </div>

        <div className="lg:mt-10">
          <DoctorAppointmentSlots
            doctor={doctorId}
            selectedHospitalLocation={selectedLocation || undefined}
            onDoctorAvailabilityChange={handleDoctorAvailabilityChange}
          />
        </div>
      </div>

      {/* Tile Buttons */}
      <div className="relative px-10 mt-5 mb-6 z-10">
        <div ref={containerRef} className="flex gap-3 overflow-x-auto scrollbar-hide scroll-smooth custom-scrollbar px-8">
          {doctordata?.profileBrief && <button onClick={() => scrollToSection("Overview")} className="px-4 py-2 border border-[#009A85] rounded-full text-sm font-medium text-[#009A85] whitespace-nowrap hover:bg-[#009A85] hover:text-white transition">Overview</button>}
          {(doctordata?.previousExperiance?.length ?? 0) > 0 && <button onClick={() => scrollToSection("Experience")} className="px-4 py-2 border border-[#009A85] rounded-full text-sm font-medium text-[#009A85] whitespace-nowrap hover:bg-[#009A85] hover:text-white transition">Experience</button>}
          {(doctordata?.awardsAchievements?.length ?? 0) > 0 && <button onClick={() => scrollToSection("Awards & Achievements")} className="px-4 py-2 border border-[#009A85] rounded-full text-sm font-medium text-[#009A85] whitespace-nowrap hover:bg-[#009A85] hover:text-white transition">Awards & Achievements</button>}
          {(doctordata?.researchPublications?.length ?? 0) > 0 && <button onClick={() => scrollToSection("Research & Publication")} className="px-4 py-2 border border-[#009A85] rounded-full text-sm font-medium text-[#009A85] whitespace-nowrap hover:bg-[#009A85] hover:text-white transition">Research & Publication</button>}
          {(doctordata?.areaOfInterest?.length ?? 0) > 0 && <button onClick={() => scrollToSection("Areas of Interest")} className="px-4 py-2 border border-[#009A85] rounded-full text-sm font-medium text-[#009A85] whitespace-nowrap hover:bg-[#009A85] hover:text-white transition">Areas of Interest</button>}
          {doctordata?.registrationNo && <button onClick={() => scrollToSection("Registration No")} className="px-4 py-2 border border-[#009A85] rounded-full text-sm font-medium text-[#009A85] whitespace-nowrap hover:bg-[#009A85] hover:text-white transition">Registration No</button>}
        </div>
      </div>

      {/* Sections */}
      <div className="space-y-12 px-5 xs:px-10">
        {(doctordata?.profileBrief?.length ?? 0) > 0 && (
          <div ref={(el) => { sectionRefs.current["Overview"] = el; }} className="scroll-mt-[160px] bg-gray-100 px-5 rounded-lg py-4">
            <h2 className="text-xl font-semibold mb-2 text-[#184A84]">Overview</h2>
            <div className="mx-5 space-y-1 text-gray-700 text-justify">
              {doctordata?.profileBrief.split(';').map((q: any) => q.trim()).filter(Boolean).map((q: any, index: any) => <div key={index}>{q}</div>)}
            </div>
          </div>
        )}
        {(doctordata?.previousExperiance?.length ?? 0) > 0 && (
          <div ref={(el) => { sectionRefs.current["Experience"] = el; }} className="scroll-mt-[160px] px-5">
            <h2 className="text-xl font-semibold mb-2 text-[#184A84]">Experience</h2>
            <ul className="space-y-3">
              {doctordata?.previousExperiance.map((exp, i) => (
                <li key={i} className="list-disc ml-6 text-justify">
                  <p className="font-medium">{exp.role}</p>
                  <p className="text-gray-600">{exp.description}</p>
                </li>
              ))}
            </ul>
          </div>
        )}
        {(doctordata?.awardsAchievements?.length ?? 0) > 0 && (
          <div ref={(el) => { sectionRefs.current["Awards & Achievements"] = el; }} className="scroll-mt-[160px] px-5">
            <h2 className="text-xl font-semibold mb-2 text-[#184A84]">Awards & Achievements</h2>
            <ul className="list-disc ml-5 space-y-1 text-gray-700">
              {doctordata?.awardsAchievements.map((award, i) => <li key={i} className="list-disc"><p className="text-gray-600">{award}</p></li>)}
            </ul>
          </div>
        )}
        {(doctordata?.researchPublications?.length ?? 0) > 0 && (
          <div ref={(el) => { sectionRefs.current["Research & Publication"] = el; }} className="scroll-mt-[160px] px-5">
            <h2 className="text-xl font-semibold mb-2 text-[#184A84]">Research & Publication</h2>
            <ul className="list-disc ml-6 space-y-1 text-gray-700">
              {doctordata?.researchPublications.map((pub, i) => <li key={i}>{pub}</li>)}
            </ul>
          </div>
        )}
        {(doctordata?.areaOfInterest?.length ?? 0) > 0 && (
          <div ref={(el) => { sectionRefs.current["Areas of Interest"] = el; }} className="scroll-mt-[160px] px-5">
            <h2 className="text-xl font-semibold mb-2 text-[#184A84]">Areas of Interest</h2>
            <ul className="space-y-3">
              {doctordata?.areaOfInterest.map((area, i) => (
                <li key={i} className="list-disc ml-6">
                  <p className="font-medium">{area.role}</p>
                  <p className="text-gray-600">{area.description}</p>
                </li>
              ))}
            </ul>
          </div>
        )}
        {(doctordata?.registrationNo?.length ?? 0) > 0 && (
          <div ref={(el) => { sectionRefs.current["Registration No"] = el; }} className="scroll-mt-[160px] px-5">
            <h2 className="text-xl font-semibold mb-2 text-[#184A84]">Registration No</h2>
            <div className="ml-5 font-semibold">{doctordata?.registrationNo}</div>
          </div>
        )}
      </div>

      {/* Callback Form */}
      <div className="flex flex-col sm:flex-row justify-between items-center gap-8 bg-[#184A84] py-5 md:py-1 px-10 rounded-2xl">
        <div className="w-full md:w-2/3">
          <h2 className="text-lg md:text-xl mb-1 text-white">Could not find what you are looking for?</h2>
          <p className="text-xl md:text-2xl font-bold mb-6 text-white">Request a Callback</p>
          <form className="flex flex-col gap-5" onSubmit={handleCallbackSubmit}>
            <div className="flex flex-col md:flex-row items-start gap-3 w-full">
              <div className="w-full md:flex-1">
                <label className="text-white">Full Name</label>
                <input
                  type="text"
                  placeholder="Name"
                  value={callbackName}
                  onChange={(e) => { setCallbackName(e.target.value); validateName(e.target.value); }}
                  onBlur={() => validateName(callbackName)}
                  className={`w-full text-xs capitalize px-4 py-2 rounded-lg border text-gray-900 focus:ring-2 focus:ring-blue-400 outline-none transition-all ${nameError ? "border-red-300 focus:ring-red-400 focus:border-red-400" : "border-gray-300"}`}
                  required
                  disabled={callbackLoading}
                />
                {nameError && <p className="mt-1 text-sm text-white">{nameError}</p>}
              </div>
              <div className="w-full md:flex-1">
  <label className="text-white">Email Address</label>

  <input
    type="email"
    placeholder="Enter Email Address"
    value={callbackEmail}
    onChange={(e) => {
      setCallbackEmail(e.target.value);

      if (emailError) {
        validateEmail(e.target.value);
      }
    }}
    onBlur={() => validateEmail(callbackEmail)}
    className={`w-full px-4 text-xs py-2 rounded-lg border text-gray-900 focus:ring-2 focus:ring-blue-400 outline-none transition-all ${
      emailError
        ? "border-red-300 focus:ring-red-400 focus:border-red-400"
        : "border-gray-300"
    }`}
    disabled={callbackLoading}
  />

  {emailError && (
    <p className="mt-1 text-sm text-white">
      {emailError}
    </p>
  )}
</div>
              <div className="w-full md:flex-1">
                <label className="text-white">Mobile Number</label>
                <input
                  type="tel"
                  placeholder="Enter Mobile Number"
                  value={callbackMobile}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[^0-9]/g, "");
                    if (rawValue.length === 0) { setCallbackMobile(""); setMobileError(""); setIsMobileValid(false); return; }
                    if (!/[6789]/.test(rawValue[0])) { setCallbackMobile(""); setIsMobileValid(false); return; }
                    const validValue = rawValue.slice(0, 10);
                    setCallbackMobile(validValue);
                    validateMobile(validValue);
                  }}
                  onBlur={() => validateMobile(callbackMobile)}
                  maxLength={10}
                  className={`w-full px-4 py-2 text-xs rounded-lg border text-gray-900 focus:ring-2 focus:ring-blue-400 outline-none transition-all ${mobileError ? "border-red-300 focus:ring-red-400 focus:border-red-400" : "border-gray-300"}`}
                  required
                  disabled={callbackLoading}
                />
                {mobileError && <p className="mt-1 text-sm text-white">{mobileError}</p>}
              </div>
            </div>
            <div className="flex items-start gap-3 w-full">
              <input type="checkbox" id="callbackConsent" checked={callbackConsent} onChange={(e) => setCallbackConsent(e.target.checked)} className="w-5 h-5 text-[#184A84] border-gray-300 rounded cursor-pointer mt-0.5" disabled={callbackLoading} />
              <label htmlFor="callbackConsent" className="text-white text-sm leading-relaxed cursor-pointer">
                Get Updates on WhatsApp. I agree to the{" "}
                <Link to="/terms_conditions" className="text-[#009A85] font-semibold underline">T&C</Link>.
              </label>
            </div>
            <button
              type="submit"
              disabled={!isNameValid || !isMobileValid || !callbackConsent || callbackLoading}
              className={`w-full md:w-auto text-white font-semibold py-2 px-8 rounded-lg transition-all duration-200 transform hover:scale-[1.02] active:scale-95 shadow-lg ${!isNameValid || !isMobileValid || !callbackConsent || callbackLoading ? "bg-gray-400 cursor-not-allowed shadow-none hover:scale-100 active:scale-100" : "bg-[#009A85] hover:bg-[#007a6a]"}`}
            >
              {callbackLoading ? (
                <span className="flex items-center gap-2">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Submitting...
                </span>
              ) : "Submit"}
            </button>
          </form>
        </div>
        <div className="hidden sm:flex justify-end w-full md:w-1/3">
          <img src={Doctors} alt="Doctor" className="w-52 md:w-72 object-contain drop-shadow-lg" />
        </div>
      </div>
    </div>
  );
};

export default DoctorAppointment;
